import type { FlightLeg } from '../../../domain/types'
import { Banner } from '@sunwebgroup/uds-ui/banner'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useIntl } from '@/intl'
import { buildFlightLegsLuggageDisplayItems, FLIGHT_LUGGAGE_EMPTY_MESSAGE_KEY } from '../../utils/flightLuggage'
import { IconRow } from '../IconRow'
import styles from './FlightLuggage.module.css'

export interface FlightLuggageProps {
  legs: FlightLeg[]
}

export function FlightLuggage({ legs }: FlightLuggageProps) {
  const { formatMessage } = useIntl()
  const displayItems = buildFlightLegsLuggageDisplayItems(legs, formatMessage)
  const isEmpty = !displayItems.length

  return (
    <div className={styles.section}>
      <Typography as="h4" variant="body-m-bold-tight">
        {formatMessage({ id: 'booking_details_flight_luggage_title' })}
      </Typography>
      {isEmpty
        ? (
            <div className={styles.emptyBanner}>
              <Banner color="informative" size="S" hasIcon contentIsCentered>
                <Banner.TextsWrapper>
                  <Banner.Text>
                    {formatMessage({ id: FLIGHT_LUGGAGE_EMPTY_MESSAGE_KEY })}
                  </Banner.Text>
                </Banner.TextsWrapper>
              </Banner>
            </div>
          )
        : (
            <div className={styles.content}>
              <ul className={styles.items}>
                {displayItems.map(item => (
                  <li key={item.glyph + item.descriptions.join()} className={styles.item}>
                    <IconRow
                      glyph={item.glyph}
                      description={(
                        <div className={styles.descriptionLines}>
                          {item.descriptions.map(line => <div key={line}>{line}</div>)}
                        </div>
                      )}
                      className={styles.iconRow}
                      size={24}
                    />
                  </li>
                ))}
              </ul>
            </div>
          )}
    </div>
  )
}
